import React, { useEffect, useState } from 'react';
import { IconButton, useTheme } from '@zydalabs/storefront-components';
import { Typography } from '@zydalabs/zac-react';
import { isServerSide } from 'common/utils';
import { IcBack } from 'common/icons';
import { StyledBackIconWrapper } from './style';

type ProductDetailsHeaderType = {
  productTitle: string;
  onBack: () => void;
};

const ProductDetailsHeader: React.FC<ProductDetailsHeaderType> = ({ productTitle, onBack }) => {
  const theme = useTheme();

  const [isHeaderTransparent, setIsHeaderTransparent] = useState<boolean>(true);
  let titleComponent = !isServerSide() && document.getElementById('title');
  let titlePosition = !isServerSide() && titleComponent?.getBoundingClientRect().top + window.pageYOffset;

  useEffect(() => {
    const setTitlePos = scrollY => {
      if (scrollY >= titlePosition - 50) setIsHeaderTransparent(false);
      else setIsHeaderTransparent(true);
    };

    const handleScroll = () => {
      const { scrollY } = window || {};
      if (titlePosition) {
        setTitlePos(scrollY);
      } else {
        titleComponent = document.getElementById('title');
        titlePosition = titleComponent?.getBoundingClientRect().top + window.pageYOffset;
        setTitlePos(scrollY);
      }
    };

    window?.addEventListener('scroll', handleScroll);
    return () => {
      window?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <StyledBackIconWrapper isHeaderTransparent={isHeaderTransparent}>
      <IconButton
        icon={IcBack}
        onClick={onBack}
        data-testid="back-icon-btn"
        color={theme.color.primary}
        withBackground
        reverseOnRtl
        width="44px"
        height="44px"
      />
      {!isHeaderTransparent && (
        <Typography variant="headingExpressive16" mx={8} testId="product-title">
          {productTitle}
        </Typography>
      )}
    </StyledBackIconWrapper>
  );
};
export default ProductDetailsHeader;
